import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-4">
            <h3 className="font-heading text-3xl md:text-4xl font-bold tracking-tight mb-4">
              Hipobuy Spread
            </h3>
            <p className="text-foreground-400 text-sm leading-relaxed max-w-sm">
              The ultimate spreadsheet research hub for smarter product discovery. We provide independent guides, comparisons, tutorials, and research resources.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-700 text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors duration-200 cursor-pointer">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-700 text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors duration-200 cursor-pointer">
                <i className="ri-pinterest-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-700 text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors duration-200 cursor-pointer">
                <i className="ri-reddit-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-700 text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors duration-200 cursor-pointer">
                <i className="ri-discord-line text-sm"></i>
              </a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-widest text-foreground-500 font-semibold mb-4">RESOURCES</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/hipobuy-spreadsheet-guide" className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-150 cursor-pointer">Spreadsheet Guide</Link>
              <Link to="/hipobuy-spreadsheet-review" className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-150 cursor-pointer">Independent Review</Link>
              <Link to="/hipobuy-spreadsheet-comparison" className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-150 cursor-pointer">Platform Comparison</Link>
              <Link to="/hipobuy-spreadsheet-beginner-guide" className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-150 cursor-pointer">Beginner Guide</Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-150 cursor-pointer">Main Platform</a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-widest text-foreground-500 font-semibold mb-4">LEGAL</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/spreadsheet-safety-guide" className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-150 cursor-pointer">Privacy Policy</Link>
              <Link to="/spreadsheet-safety-guide" className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-150 cursor-pointer">Terms of Service</Link>
              <Link to="/spreadsheet-safety-guide" className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-150 cursor-pointer">Disclaimer</Link>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-widest text-foreground-500 font-semibold mb-4">SAFETY</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/spreadsheet-safety-guide" className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-150 cursor-pointer">Safety Center</Link>
              <Link to="/spreadsheet-safety-guide" className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-150 cursor-pointer">QC Guidelines</Link>
              <Link to="/spreadsheet-safety-guide" className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-150 cursor-pointer">Report Issues</Link>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-widest text-foreground-500 font-semibold mb-4">CONTACT</h4>
            <div className="flex flex-col gap-2.5">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-150 cursor-pointer">Visit Main Site</a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; 2026 Hipobuy Spread. This website is an independent educational resource and is not officially affiliated with any marketplace.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-xs text-foreground-600 hover:text-background-50 transition-colors duration-150 cursor-pointer">Home</Link>
            <Link to="/hipobuy-spreadsheet-guide" className="text-xs text-foreground-600 hover:text-background-50 transition-colors duration-150 cursor-pointer">Guide</Link>
            <Link to="/hipobuy-spreadsheet-review" className="text-xs text-foreground-600 hover:text-background-50 transition-colors duration-150 cursor-pointer">Review</Link>
            <Link to="/spreadsheet-safety-guide" className="text-xs text-foreground-600 hover:text-background-50 transition-colors duration-150 cursor-pointer">Safety</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}